<template>
	<div>
		<div class="row input-wrapper" :class="{'has-error': error.length > 0}">
			<div class="col-xs-12 input-label" :class="{'has-error': error.length > 0}" @click="openInputFile"><i v-if="icon" :class="['input-icon', 'fas', 'fa-fw', icon, {'has-error': error.length > 0}]"></i> {{ label }}</div>
			<div class="col-xs-12 input-element" :class="{'has-icon': icon, 'has-error': error.length > 0}" ref="div_element">
				<ul class="input-element-list" v-if="list.length > 0">
					<li class="input-element-file" v-for="(file, index) in list" :key="'file-' + index">
						{{ file.name }} <button class="file-remove" title="Remover arquivo" @click="updateFiles(index)"><i class="fas fa-times"></i></button>
					</li>
				</ul>
			</div>
		</div>
		<div class="input-error" :class="{'has-error': error.length > 0}">{{ error }}</div>
	</div>
</template>

<script>
	export default {
		name: "DeliveryFormFile",

		props: [ "label", "icon", "files" ],

		data: function() {
			return {
				has_focus: false,
				error: "",

				list: this.files,
			}
		},

		watch: {
			files: function() {
				this.list = this.files;
				this.validate();
			}
		},

		methods: {
			validate: function() {
				if (this.list.length == 0) {
					this.error = "* Selecionar arquivos é obrigatório.";
					return;
				}

				this.error = "";
			},

			updateFiles: function(index) {
				this.$emit("update", index);
			},

			getValue: function() {
				return this.list;
			},

			openInputFile: function() {
				this.$parent.openInputFile();
			},
		}
	}
</script>

<style scoped>
.input-wrapper {
	color: #666;
}

.input-wrapper.has-error {
	color: red;
}






.input-label {
	width: 100%;
	height: 40px;
	line-height: 40px;
	margin-bottom: 10px;
	color: #999;
	transition: all 0.2s linear;
	cursor: pointer;
}

.input-label.has-icon {
	margin-left: 40px;
}

.input-label.has-focus {
	top: 45px;
	margin-left: 40px;
	font-size: 12px;
	color: #666;
}

.input-label.has-error {
	color: red;
}









.input-icon {
	height: 40px;
	line-height: 40px;
	margin-right: 10px;
	text-align: center;
	color: #666;
}

.input-icon.has-error {
	color: red;
}







.input-element {
	width: 100%;
	border: none;
	border-bottom: 1px solid #aaa;
	background: none;
	
    overflow-y: auto;
    max-height: 195px;
}

.input-element > ul {
	margin: 0px;
	padding-left: 0px;
}

.input-element > ul > li {
	list-style: none;
	line-height: 30px;

	background-color: #cdcdcd;
	padding: 2px 5px;
	border-radius: 4px;
	margin: 7px 0px;
}

.input-element.has-error {
	border-bottom: 1px solid red;
}








.input-error {
	width: 100%;
	font-size: 12px;
	height: 25px;
	line-height: 35px;
	margin-bottom: 10px;
}

.has-error.input-error {
	color: red;
}

/* para o Fire Fox */
#campo::-we-range-thumb {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background: #666;
  border: none;
}

/* para o Fire Fox */
#campo::-moz-range-thumb {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background: #666;
  border: none;
}

/* para browsers da MS */
#campo::-ms-range-thumb {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background: #666;
  border: none;
}

#campo::-webkit-slider-thumb{

  all:unset; /* limpa os estilos iniciais */
  -webkit-appearance: none; /* remove a aparencia padão */
  border: none;
  
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: #666;
}

input:disabled {
	cursor: not-allowed;
}

.file-remove {
	color: #666;
    font-size: 15px;
    height: 30px;
	float: right;
    background-color: transparent;
    border: none;
}
</style>